import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DocumentoService } from '../../services/documento.service';
import { MatSelectModule } from '@angular/material/select';
import { AppTitleService } from '../../services/app-title.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EstadosDocumentoComponent } from '../../commons/estados-documento/estados-documento.component';
import { DlgDestinoComponent } from '../nuevo/dlg-destino/dlg-destino.component';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ListadoDocumentoPaginado, Documento } from '../../models/Document';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentType } from '../../models/DocumentType'; import { merge, startWith, switchMap, catchError, EMPTY, map } from 'rxjs';
import { CustomPaginator } from '../../commons/custom-paginator/custom-paginator';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { NoDataFoundComponent } from '../../commons/no-data-found/no-data-found.component';
import { MatCardModule } from '@angular/material/card';
import { ParticipantesType } from '../../models/ParticipantesType';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { BusquedaStateService } from '../../services/busqueda-state.service';

export function atLeastOneValidator(controls: string[]): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const hasAtLeastOne = controls.some((controlName) => {
      const control = group.get(controlName);
      return control && control.value && control.value.toString().trim() !== '';
    });

    return hasAtLeastOne ? null : { atLeastOneRequired: true };
  };
}


export interface FilterData {
  documentNumber: string,
  referenceNumber: string,
  initialDate: string | null
  endDate: string | null
  searchText: string
  anio: number
  numero: number
  documentType: number
  de: string
  para: string
  copia: string
}

@Component({
  selector: 'app-busqueda',
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    CapitalizePipe,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressBarModule,
    NoDataFoundComponent,
    EstadosDocumentoComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  templateUrl: './busqueda.component.html',
  styleUrl: './busqueda.component.scss'
})
export class BusquedaComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['movimiento','estados', 'asunto', 'fecha', 'numeroDocumento'];
  documentsPaginated: ListadoDocumentoPaginado | undefined
  dataSource = new MatTableDataSource<Documento>([]);
  selection = new SelectionModel<Documento>(true, []);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  resultsLength = 0;
  isLoadingResults = true;

  documentTypes: DocumentType[] | undefined

  maxDate = new Date()

  participantes: ParticipantesType = {
    origen: [],
    destino: [],
    copia: []
  };
  snackbarData: ScnackbarData = {}

  filterForm = new FormGroup(
    {
      numero: new FormControl('', [Validators.pattern('^(?:\\d{4}-)?\\d+$')]),
      numeroDocumento: new FormControl(""),
      fechaInicio: new FormControl(),
      fechaFin: new FormControl(),
      searchText: new FormControl(""),
      documentType: new FormControl(""),
    }
  );

  constructor(
    private documentoSrv: DocumentoService,
    private documentTypeService: DocumentTypeService,
    public dialog: MatDialog,
    private router: Router,
    private toast: ToastService,
    private dateService: DateService,
    private busquedaState: BusquedaStateService
  ) {
    inject(AppTitleService).setTitle("B\xfasqueda Avanzada");
  }

  ngOnInit(): void {
    if (this.busquedaState.hasState() && this.busquedaState.participantes) {
      this.participantes = { ...this.busquedaState.participantes };
    }
  }

  ngAfterViewInit(): void {
    if (this.busquedaState.hasState()) {
      this.restoreState();
    }

    this.documentTypeService.list().subscribe({
      next: (response: DocumentType[]) => {
        this.documentTypes = response;
        let documentTypeDescription = "Oficio"

        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);

        if (defaultType) {
          this.filterForm.controls.documentType.setValue("-1")

          merge(this.sort.sortChange, this.paginator.page).pipe(
            startWith({}),
          ).subscribe({
            next: () => {
              if (this.busquedaState.pageIndex !== this.paginator.pageIndex) {
                this.busquedaState.clear();
              }
              if (this.busquedaState.hasState()) {
                this.restoreState();
                return;
              }
              this.fetchData(this.paginator.pageIndex);
            }
          })
        }
      }
    });
  }

  private restoreState() {
    if (this.busquedaState.filterData) {
      // Reconstruir el número flow desde año y número
      let numeroFlow = '';
      if (this.busquedaState.filterData.anio && this.busquedaState.filterData.numero) {
        numeroFlow = `${this.busquedaState.filterData.anio}-${this.busquedaState.filterData.numero}`;
      } else if (this.busquedaState.filterData.numero) {
        numeroFlow = this.busquedaState.filterData.numero.toString();
      }

      this.filterForm.setValue({
        numero: numeroFlow,
        numeroDocumento: this.busquedaState.filterData.documentNumber,
        fechaInicio: this.busquedaState.filterData.initialDate ? this.dateService.formatCustomStringToDate(this.busquedaState.filterData.initialDate) : null,
        fechaFin: this.busquedaState.filterData.endDate ? this.dateService.formatCustomStringToDate(this.busquedaState.filterData.endDate) : null,
        searchText: this.busquedaState.filterData.searchText,
        documentType: this.busquedaState.filterData.documentType.toString(),
      });
    }
    if (this.busquedaState.documentsPaginated) {
      this.documentsPaginated = { ...this.busquedaState.documentsPaginated };
      this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos);
      this.resultsLength = this.documentsPaginated.totalDocumentos;
      this.paginator.pageIndex = this.busquedaState.pageIndex;
      this.isLoadingResults = false;
    }
  }

  buscarFlow() {
    this.filterForm.controls.searchText.setValue("")
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  private fetchData(pageIndex: number) {
    const filterData = this.createFilterData();
    this.isLoadingResults = true;
    this.documentoSrv.getDocumentosBusquedaAvanzada(
      filterData.documentNumber,
      filterData.referenceNumber,
      filterData.initialDate || "",
      filterData.endDate || "",
      filterData.searchText,
      filterData.documentType,
      filterData.anio,
      filterData.numero,
      filterData.de,
      filterData.para,
      filterData.copia,
      pageIndex + 1,
    ).subscribe({
      next: (response) => {
        this.documentsPaginated = response;
        this.dataSource = new MatTableDataSource<Documento>(response.documentos);
        this.resultsLength = response.totalDocumentos;
        this.isLoadingResults = false;
        this.busquedaState.save(filterData, response, this.participantes, pageIndex);
      },
      error: (e: HttpErrorResponse) => {
        this.isLoadingResults = false;
        this.snackbarData.message = "Tuvimos problemas en buscar datos";
        this.snackbarData.style = SnackbarStyles.Error;
        this.toast.show(this.snackbarData);
      }
    });
  }

  fectchAndInitializeDataSource() {
    this.paginator.pageIndex = 0;
    this.fetchData(0);
  }

  private createFilterData(): FilterData {
    // Parsear el número para extraer año y número
    let anio = 0;
    let numero = 0;    
    const numeroFlow = this.filterForm.controls.numero.value?.trim();
    if (numeroFlow) {
      const parts = numeroFlow.split('-');
      if (parts.length === 2) {
        // Formato con año: 2025-67673
        anio = parseInt(parts[0]);
        numero = parseInt(parts[1]);
      } else if (parts.length === 1) {
        // Solo número: 67673
        anio = -1;
        numero = parseInt(parts[0]);
      }
    }

    const filterData: FilterData = {
      documentNumber: this.filterForm.controls.numeroDocumento.value!,
      referenceNumber: "",
      initialDate: this.filterForm.controls.fechaInicio.value ? this.dateService.formatDateToCustomString(this.filterForm.controls.fechaInicio.value!) : "",
      endDate: this.filterForm.controls.fechaFin.value ? this.dateService.formatDateToCustomString(this.filterForm.controls.fechaFin.value!) : "",
      documentType: parseInt(this.filterForm.controls.documentType.value!),
      anio: anio,
      numero: numero,
      searchText: this.filterForm.controls.searchText.value!,
      de: this.participantes.origen.map(p => p.id).join(","),
      para: this.participantes.destino.map(p => p.id).join(","),
      copia: this.participantes.copia.map(p => p.id).join(",")
    }

    return filterData
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource!.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource!.data);
  }

  checkboxLabel(row?: Documento): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

  mostrarResumen(row: any) {
    const data = {
      bandejaIndex: 1
    }
    this.router.navigateByUrl("/resumen/" + row.idTarea, { state: data })
  }

  openDlgDestino() {
    const dlgDestino = this.dialog.open(DlgDestinoComponent, {
      width: '80vw',
      maxWidth: '80vw',
      data: this.participantes
    });

    dlgDestino.afterClosed().subscribe(result => {
      if (result) {
        this.participantes = result;
      }
    });
  }

  limpiarFiltros() {
    this.busquedaState.clear();
    this.participantes = {
      origen: [],
      destino: [],
      copia: []
    };
    this.filterForm.reset();
    this.filterForm.controls.documentType.setValue("-1")
    this.dataSource = new MatTableDataSource<Documento>([]);
  }

  onAyuda() {
     window.open('https://gemini.google.com/share/e0fbc652afd3', '_blank');
  }

}
